import axios from "axios";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoginRegisterForm.css";

const LoginRegisterForm = () => {
  const [activeTab, setActiveTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setErrors({});
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let validationErrors = {};

    if (activeTab === "register") {
      if (!formData.firstName.trim())
        validationErrors.firstName = "نام را وارد کنید.";
      if (!formData.lastName.trim())
        validationErrors.lastName = "نام خانوادگی را وارد کنید.";
      if (!formData.phone.trim())
        validationErrors.phone = "شماره تلفن را وارد کنید.";
      if (!formData.email.trim())
        validationErrors.email = "ایمیل را وارد کنید.";
      if (!formData.password.trim())
        validationErrors.password = "رمز عبور را وارد کنید.";
      if (!formData.confirmPassword.trim())
        validationErrors.confirmPassword = "تکرار رمز عبور را وارد کنید.";
      if (formData.password !== formData.confirmPassword) {
        validationErrors.confirmPassword = "رمز عبور و تکرار آن مطابقت ندارند.";
      }
    } else {
      if (!formData.email.trim())
        validationErrors.email = "ایمیل را وارد کنید.";
      if (!formData.password.trim())
        validationErrors.password = "رمز عبور را وارد کنید.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      let response;
      if (activeTab === "register") {
        response = await axios.post(
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/register",
          {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            phone: formData.phone,
            password: formData.password,
          }
        );

        if (response.data.is_status) {
          toast.success(`✅ ${response.data.message}`, {
            className: "toast-message",
            position: "top-center",
          });

          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            password: "",
            confirmPassword: "",
          });

          setTimeout(() => {
            setActiveTab("login");
          }, 1500);
        } else {
          toast.error(`❌ ${response.data.message}`, {
            className: "toast-message",
            position: "top-center",
          });
        }
      } else {
        response = await axios.post(
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/login",
          {
            email: formData.email,
            password: formData.password,
          }
        );

        if (response.data.is_status) {
          toast.success(`✅ ${response.data.message}`, {
            className: "toast-message",
            position: "top-center",
          });

          localStorage.setItem("access_token", response.data.data.access_token);

          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          toast.error(`❌ ${response.data.message}`, {
            className: "toast-message",
            position: "top-center",
          });
        }
      }
    } catch (error) {
      if (error.response) {
        toast.error(`❌ ${error.response.data.message}`, {
          className: "toast-message",
          position: "top-center",
        });
      } else {
        toast.error("❌ خطایی رخ داده است، لطفاً مجدداً تلاش کنید.", {
          className: "toast-message",
          position: "top-center",
        });
      }
    }
    setLoading(false);
  };

  return (
    <div className="login-register-container">
      <ToastContainer autoClose={3000} hideProgressBar={true} />

      <button
        className="back-to-home"
        onClick={() => (window.location.href = "/")}
      >
        ⬅ بازگشت به خانه
      </button>

      <div className="login-register-box">
        <div className="tabs">
          <button
            className={activeTab === "login" ? "active-tab" : ""}
            onClick={() => handleTabChange("login")}
          >
            ورود
          </button>
          <button
            className={activeTab === "register" ? "active-tab" : ""}
            onClick={() => handleTabChange("register")}
          >
            ثبت نام
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form-container">
          {activeTab === "register" && (
            <>
              <input
                type="text"
                name="firstName"
                placeholder="نام*"
                value={formData.firstName}
                onChange={handleChange}
              />
              {errors.firstName && (
                <p className="error-message">{errors.firstName}</p>
              )}

              <input
                type="text"
                name="lastName"
                placeholder="نام خانوادگی*"
                value={formData.lastName}
                onChange={handleChange}
              />
              {errors.lastName && (
                <p className="error-message">{errors.lastName}</p>
              )}

              <input
                type="text"
                name="phone"
                placeholder="شماره تلفن*"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <p className="error-message">{errors.phone}</p>}
            </>
          )}

          <input
            type="email"
            name="email"
            placeholder="ایمیل*"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error-message">{errors.email}</p>}

          <input
            type="password"
            name="password"
            placeholder="رمز عبور*"
            value={formData.password}
            onChange={handleChange}
          />
          {errors.password && (
            <p className="error-message">{errors.password}</p>
          )}

          {activeTab === "register" && (
            <>
              <input
                type="password"
                name="confirmPassword"
                placeholder="تکرار رمز عبور*"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              {errors.confirmPassword && (
                <p className="error-message">{errors.confirmPassword}</p>
              )}
            </>
          )}

          <button type="submit" className="submit-btn">
            {loading ? (
              <span className="spinner"></span>
            ) : activeTab === "login" ? (
              "ورود"
            ) : (
              "ثبت نام"
            )}
          </button>

          {activeTab === "login" && (
            <div className="forgot-password-container">
              <a href="/forget-password" className="forgot-password-link">
                فراموشی رمز ورود ؟
              </a>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginRegisterForm;
